// extracted by mini-css-extract-plugin
export default {"divider":"ClusterForm_divider__mBhFo","title":"ClusterForm_title__5c+5O","header":"ClusterForm_header__T6xDZ"};